export default {
  title: 'Download SOSAFE',
  description: "Let's take care of each other. The more we are, the safer we will be!",
  googlePlayButton: 'Download on Google Play',
  appGalleryButton: 'Download on AppGallery',
};
